import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/sentry-example-page')({
  head: () => ({
    meta: [{ title: 'Sentry Test | Unbreakable' }],
  }),
  component: SentryExamplePage,
})

function SentryExamplePage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      <h1 className="text-2xl font-bold">Sentry Test Page</h1>
      <button
        className="rounded bg-red-500 px-4 py-2 text-white"
        onClick={() => {
          throw new Error('Sentry Frontend Test Error')
        }}
      >
        Throw Test Error
      </button>
    </div>
  )
}
